import { Component, computed, effect, inject, OnDestroy, OnInit, signal, Signal, WritableSignal } from '@angular/core';
import { Router } from '@angular/router';

import { TurnoAsignado } from '../../models/Turno.model';
import { TurnoActual } from '../../components/turno-actual/turno-actual';
import { ListaAsignados } from '../../components/lista-asignados/lista-asignados';
import { SalaService } from '../../services/api/sala.service';
import { MultimediaService, PlaylistItem } from '../../services/api/multimedia.service';
import { CredentialsService } from '../../services/local/credentials.service';

@Component({
  selector: 'app-turnos.page',
  imports: [ListaAsignados, TurnoActual],
  templateUrl: './turnos.page.html',
  styleUrl: './turnos.page.scss'
})
export class TurnosPage implements OnDestroy {
  private closeEventSource: Signal<() => void> = signal(() => {});
  private audio = new Audio('/sounds/ding.mp3');
  private multimediaService = inject(MultimediaService);

  turnoActual: Signal<TurnoAsignado | null> = signal(null);
  segundoturno: Signal<TurnoAsignado | null> = signal(null);
  tercerTurno: Signal<TurnoAsignado | null> = signal(null);
  listaAsignados: Signal<TurnoAsignado[]> = signal([]);
  sala: WritableSignal<string> = signal('');
  multimedia: WritableSignal<PlaylistItem | null> = signal(null);
  multimedia2: WritableSignal<PlaylistItem | null> = signal(null);
  indexMultimedia = 0;
  indexMultimedia2 = 1;
  contadorSegundos = 0;
  contadorSegundos2 = 0;

  constructor(salaService: SalaService, router: Router, credentialsService: CredentialsService) {
    const salaId = credentialsService.salaId();
    if (!salaId) {
      router.navigate(['/admin']);
      return;
    }

    this.sala.set(credentialsService.sala() || '');
    const asignadosSignal = salaService.getTurnosDeSala(salaId);
    this.turnoActual = computed(() => asignadosSignal().fila.length > 0 ? asignadosSignal().fila[0] : null);
    this.segundoturno = computed(() => asignadosSignal().fila.length > 1 ? asignadosSignal().fila[1] : null);
    this.tercerTurno = computed(() => asignadosSignal().fila.length > 2 ? asignadosSignal().fila[2] : null);
    this.listaAsignados = computed(() => {
      const fila = asignadosSignal().fila;
      return fila.length > 3 ? fila.slice(3) : [];
    });

    this.closeEventSource = computed(() => asignadosSignal().close);

    effect(() => {
      const turno = this.turnoActual();
      if (turno) {
        this.playDingSound();
      }
    });

    this.iniciarMultimedia(salaId);
  }

  async iniciarMultimedia(salaId: string): Promise<void> {
    const playlist = await this.multimediaService.getMultimediaDeSala(salaId);
    if (playlist.length > 0) {
      this.multimedia.set(playlist[0]);
    }

    if (playlist.length > 1) {
      this.multimedia2.set(playlist[1]);
    }

    if (playlist.length > 0) {
      setInterval(() => {
        this.contadorSegundos++;
        const item = this.multimedia();
        if (item && this.contadorSegundos >= item.durationSec) {
          if ((this.indexMultimedia + 3) > playlist.length) {
            this.indexMultimedia = 0;
          } else {
            this.indexMultimedia += 2;
          }

          this.multimedia.set(playlist[this.indexMultimedia]);
          this.contadorSegundos = 0;
        }

        this.contadorSegundos2++;
        const item2 = this.multimedia2();
        if (item2 && this.contadorSegundos2 >= item2.durationSec) {
          if ((this.indexMultimedia2 + 3) > playlist.length) {
            this.indexMultimedia2 = 1;
          } else {
            this.indexMultimedia2 += 2;
          }

          this.multimedia2.set(playlist[this.indexMultimedia2]);
          this.contadorSegundos2 = 0;
        }
      }, 1000);
    }
  }

  private playDingSound() {
    try {
      this.audio.currentTime = 0; // Reset to beginning
      this.audio.play().catch(error => {
        console.warn('Could not play ding sound:', error);
      });
    } catch (error) {
      console.warn('Error playing ding sound:', error);
    }
  }

  ngOnDestroy() {
    if (this.closeEventSource()) {
      this.closeEventSource()();
    }
  }

}
